export function resolvePayfacSuccessRedirectDelayMs({
  isPayfac,
  transitionStatus,
  transitionStartedAt,
  nowMs,
  minDisplayMs = 800,
  baseDelayMs = 400,
}) {
  if (!isPayfac || transitionStatus !== 'PAYMENT_SUCCESS' || transitionStartedAt <= 0) {
    return baseDelayMs;
  }

  const elapsedMs = Math.max(0, nowMs - transitionStartedAt);
  return Math.max(baseDelayMs, minDisplayMs - elapsedMs);
}

export function shouldShowPayfacIframeLoadingMask({
  isPayfac,
  currentUrl,
  iframeSrc,
}) {
  if (!isPayfac) {
    return false;
  }

  const normalizedCurrentUrl = (currentUrl || '').trim().toLowerCase();
  const normalizedIframeSrc = (iframeSrc || '').trim().toLowerCase();
  return normalizedCurrentUrl === 'about:blank' || normalizedIframeSrc === 'about:blank';
}
